import React, { Suspense } from 'react';
import { Route, Switch, Router } from 'react-router-dom';
import { connect } from 'react-redux';
import ResetScrollSite from '@/components/reset-scroll-site';
import JsLoading from '@/components/js-loading';
import OutesetLayout from '@/components/outest-layout';
import ErrorBoundary from '@/components/error-boundary';
import history from '../history';
import { matchPath } from 'react-router-dom';
import globalRoutes from './global-routes';
import TopGlobalNavigation from '@/components/TopGlobalNavigation';

window.matchPath = matchPath;

function _invalidate(condition, msg) {
  if (process.env.NODE_ENV === 'development') {
    if (condition) throw new Error(msg);
  }
}

const defaultFloderComponent = (props) => props.children;

// 递归生成子路由
function generateRoute(path = '', menus) {
  if (!menus || !menus.length) return null;

  return menus
    .filter((item) => !item.ignoreInRouter)
    .map((item) => {
      _invalidate(React.isValidElement(item.component), '路径 ' + path + ' 下的路径 ' + item.path + ' component不合法');
      const PageComponent = item.component || defaultFloderComponent;
      if (item.menus) {
        return (
          <Route
            title={item.title}
            relativePath={item.path}
            key={path + item.path}
            path={path + item.path}
            hideInNav={item.hideInNav}
            parentPath={path}
            businessId={item.businessId}
            // 专为埋点添加
            getlog={item.getlog}
          >
            <PageComponent>
              <Switch>{generateRoute(path + item.path, item.menus)}</Switch>
            </PageComponent>
          </Route>
        );
      } else {
        return (
          <Route
            exact
            hideInNav={item.hideInNav}
            // 专为埋点添加
            getlog={item.getlog}
            title={item.title}
            key={path + item.path}
            getLink={item.getLink}
            path={path + item.path}
            parentPath={path}
            relativePath={item.path}
            businessId={item.businessId}
            component={PageComponent}
          />
        );
      }
    });
}

export default connect((state) => ({ menus: state.menus }))((props) => {
  return (
    <Router history={history}>
      <ResetScrollSite>
        <Switch>
          {globalRoutes()}
          <Route path="*">
            <TopGlobalNavigation>
              <OutesetLayout>
                <Suspense fallback={<JsLoading />}>
                  <ErrorBoundary>
                    <Switch>{generateRoute('', props.menus)}</Switch>
                  </ErrorBoundary>
                </Suspense>
              </OutesetLayout>
            </TopGlobalNavigation>
          </Route>
        </Switch>
      </ResetScrollSite>
    </Router>
  );
});
